import { Center, Circle, Text, Heading, Box, Spacer, useTheme } from '@vitvio/design-system';
import { IoCalendar } from 'react-icons/io5';
import { Content } from './Content';

export function MissingSetupScreen() {
  const { getColor } = useTheme();
  return (
    <Content>
      <Center transform={'translateY(-50%)'} position="absolute" top="50%" width="100%">
        <Box position={'relative'} textAlign={'center'}>
          <Circle
            size="57px"
            bg={getColor('bg.accent')}
            color={getColor('fg')}
            marginLeft={'auto'}
            marginRight={'auto'}
          >
            <IoCalendar size={'32px'} />
          </Circle>
          <Spacer height={6} />
          <Heading>No operating rooms created</Heading>
          <Spacer height={6} />
          <Text>It looks like we don’t have any operating rooms created at the moment.</Text>
          <Text>We’re working on setting them up, so please check back a little later.</Text>

          <Spacer height={4} />

          <Text>If you have any questions in the meantime, please reach out to us at</Text>
          <Text>
            <a href="mailto:support@vitvio.com">support@vitvio.com</a>.
          </Text>
          <Spacer height={4} />
          <Text>Thanks for your patience!</Text>
        </Box>
      </Center>
    </Content>
  );
}
